/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotMsgContactsResponse,
  ApiEnvelopeBotMsgConversationResponse,
  ApiEnvelopeBotMsgMarkReadResponse,
  ApiEnvelopeBotMsgNotificationDto,
  ApiEnvelopeBotMsgSendResponse,
  BotMsgGetConversationParams,
  BotMsgMarkReadRequest,
  BotMsgNotificationDto,
  BotMsgSendRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botMsgGetContactsResponse200 = {
  data: ApiEnvelopeBotMsgContactsResponse
  status: 200
}

export type botMsgGetContactsResponse401 = {
  data: ApiEnvelopeBotMsgContactsResponse
  status: 401
}

export type botMsgGetContactsResponse403 = {
  data: ApiEnvelopeBotMsgContactsResponse
  status: 403
}

export type botMsgGetContactsResponse404 = {
  data: ApiEnvelopeBotMsgContactsResponse
  status: 404
}

export type botMsgGetContactsResponseSuccess = (botMsgGetContactsResponse200) & {
  headers: Headers;
};
export type botMsgGetContactsResponseError = (botMsgGetContactsResponse401 | botMsgGetContactsResponse403 | botMsgGetContactsResponse404) & {
  headers: Headers;
};

export type botMsgGetContactsResponse = (botMsgGetContactsResponseSuccess | botMsgGetContactsResponseError)

export const getBotMsgGetContactsUrl = (botId: string,) => {




  return `/api/botengine/${botId}/msgs/contacts`
}

export const useBotMsgGetContactsHook = (): (botId: string, options?: RequestInit) => Promise<botMsgGetContactsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotMsgGetContactsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botMsgGetConversationResponse200 = {
  data: ApiEnvelopeBotMsgConversationResponse
  status: 200
}

export type botMsgGetConversationResponse401 = {
  data: ApiEnvelopeBotMsgConversationResponse
  status: 401
}

export type botMsgGetConversationResponse403 = {
  data: ApiEnvelopeBotMsgConversationResponse
  status: 403
}

export type botMsgGetConversationResponse404 = {
  data: ApiEnvelopeBotMsgConversationResponse
  status: 404
}

export type botMsgGetConversationResponseSuccess = (botMsgGetConversationResponse200) & {
  headers: Headers;
};
export type botMsgGetConversationResponseError = (botMsgGetConversationResponse401 | botMsgGetConversationResponse403 | botMsgGetConversationResponse404) & {
  headers: Headers;
};

export type botMsgGetConversationResponse = (botMsgGetConversationResponseSuccess | botMsgGetConversationResponseError)

export const getBotMsgGetConversationUrl = (botId: string,
    params?: BotMsgGetConversationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/${botId}/msgs/conversation?${stringifiedParams}` : `/api/botengine/${botId}/msgs/conversation`
}

export const useBotMsgGetConversationHook = (): (botId: string,
    params?: BotMsgGetConversationParams, options?: RequestInit) => Promise<botMsgGetConversationResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: BotMsgGetConversationParams, options?: RequestInit) => {

        return customFetcher(getBotMsgGetConversationUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botMsgSendResponse200 = {
  data: ApiEnvelopeBotMsgSendResponse
  status: 200
}

export type botMsgSendResponse400 = {
  data: ApiEnvelopeBotMsgSendResponse
  status: 400
}

export type botMsgSendResponse401 = {
  data: ApiEnvelopeBotMsgSendResponse
  status: 401
}

export type botMsgSendResponse403 = {
  data: ApiEnvelopeBotMsgSendResponse
  status: 403
}

export type botMsgSendResponse404 = {
  data: ApiEnvelopeBotMsgSendResponse
  status: 404
}

export type botMsgSendResponseSuccess = (botMsgSendResponse200) & {
  headers: Headers;
};
export type botMsgSendResponseError = (botMsgSendResponse400 | botMsgSendResponse401 | botMsgSendResponse403 | botMsgSendResponse404) & {
  headers: Headers;
};

export type botMsgSendResponse = (botMsgSendResponseSuccess | botMsgSendResponseError)

export const getBotMsgSendUrl = (botId: string,) => {




  return `/api/botengine/${botId}/msgs/send`
}

export const useBotMsgSendHook = (): (botId: string,
    botMsgSendRequest?: BotMsgSendRequest, options?: RequestInit) => Promise<botMsgSendResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    botMsgSendRequest?: BotMsgSendRequest, options?: RequestInit) => {

        return customFetcher(getBotMsgSendUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botMsgSendRequest)
  }
);
      }
  }


export type botMsgMarkReadResponse200 = {
  data: ApiEnvelopeBotMsgMarkReadResponse
  status: 200
}

export type botMsgMarkReadResponse401 = {
  data: ApiEnvelopeBotMsgMarkReadResponse
  status: 401
}

export type botMsgMarkReadResponse403 = {
  data: ApiEnvelopeBotMsgMarkReadResponse
  status: 403
}

export type botMsgMarkReadResponse404 = {
  data: ApiEnvelopeBotMsgMarkReadResponse
  status: 404
}

export type botMsgMarkReadResponseSuccess = (botMsgMarkReadResponse200) & {
  headers: Headers;
};
export type botMsgMarkReadResponseError = (botMsgMarkReadResponse401 | botMsgMarkReadResponse403 | botMsgMarkReadResponse404) & {
  headers: Headers;
};

export type botMsgMarkReadResponse = (botMsgMarkReadResponseSuccess | botMsgMarkReadResponseError)

export const getBotMsgMarkReadUrl = (botId: string,) => {




  return `/api/botengine/${botId}/msgs/read`
}

export const useBotMsgMarkReadHook = (): (botId: string,
    botMsgMarkReadRequest?: BotMsgMarkReadRequest, options?: RequestInit) => Promise<botMsgMarkReadResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    botMsgMarkReadRequest?: BotMsgMarkReadRequest, options?: RequestInit) => {

        return customFetcher(getBotMsgMarkReadUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botMsgMarkReadRequest)
  }
);
      }
  }


export type botMsgGetNotificationPrefResponse200 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 200
}

export type botMsgGetNotificationPrefResponse401 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 401
}

export type botMsgGetNotificationPrefResponse403 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 403
}

export type botMsgGetNotificationPrefResponse404 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 404
}

export type botMsgGetNotificationPrefResponseSuccess = (botMsgGetNotificationPrefResponse200) & {
  headers: Headers;
};
export type botMsgGetNotificationPrefResponseError = (botMsgGetNotificationPrefResponse401 | botMsgGetNotificationPrefResponse403 | botMsgGetNotificationPrefResponse404) & {
  headers: Headers;
};

export type botMsgGetNotificationPrefResponse = (botMsgGetNotificationPrefResponseSuccess | botMsgGetNotificationPrefResponseError)

export const getBotMsgGetNotificationPrefUrl = (botId: string,) => {




  return `/api/botengine/${botId}/msgs/notifications`
}

export const useBotMsgGetNotificationPrefHook = (): (botId: string, options?: RequestInit) => Promise<botMsgGetNotificationPrefResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotMsgGetNotificationPrefUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botMsgSetNotificationPrefResponse200 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 200
}

export type botMsgSetNotificationPrefResponse401 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 401
}

export type botMsgSetNotificationPrefResponse403 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 403
}

export type botMsgSetNotificationPrefResponse404 = {
  data: ApiEnvelopeBotMsgNotificationDto
  status: 404
}

export type botMsgSetNotificationPrefResponseSuccess = (botMsgSetNotificationPrefResponse200) & {
  headers: Headers;
};
export type botMsgSetNotificationPrefResponseError = (botMsgSetNotificationPrefResponse401 | botMsgSetNotificationPrefResponse403 | botMsgSetNotificationPrefResponse404) & {
  headers: Headers;
};

export type botMsgSetNotificationPrefResponse = (botMsgSetNotificationPrefResponseSuccess | botMsgSetNotificationPrefResponseError)

export const getBotMsgSetNotificationPrefUrl = (botId: string,) => {




  return `/api/botengine/${botId}/msgs/notifications`
}

export const useBotMsgSetNotificationPrefHook = (): (botId: string,
    botMsgNotificationDto?: BotMsgNotificationDto, options?: RequestInit) => Promise<botMsgSetNotificationPrefResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    botMsgNotificationDto?: BotMsgNotificationDto, options?: RequestInit) => {

        return customFetcher(getBotMsgSetNotificationPrefUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botMsgNotificationDto)
  }
);
      }
  }


